import { render, staticRenderFns } from "./NewLayout.vue?vue&type=template&id=59c66fe5&"
import script from "./NewLayout.vue?vue&type=script&lang=js&"
export * from "./NewLayout.vue?vue&type=script&lang=js&"
import style0 from "./NewLayout.vue?vue&type=style&index=0&id=59c66fe5&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports